/**
 * GENERATED FILE — do not edit by hand.
 *
 * Source: docs/04-DESIGN-SYSTEM.md §4 (canonical status language).
 * Regenerate: pnpm check:status --write
 *
 * docs/04 §4 states that a status not on this list requires a doc change first.
 * Typing status values against `StatusKey` makes that a compile error rather
 * than a review catch, and `scripts/ci/status-language-lint.ts` fails the build
 * if this file drifts from the doc.
 */

/** Chip colour family; each pairs a background with its required dark text. */
export type StatusFamily = 'ok' | 'neutral' | 'info' | 'amber' | 'red' | 'gold';

export interface StatusDefinition {
  readonly label: string;
  readonly family: StatusFamily;
}

export const STATUSES = {
  active: { label: 'Active', family: 'ok' },
  inactive: { label: 'Inactive', family: 'neutral' },
  draft: { label: 'Draft', family: 'info' },
  pending: { label: 'Pending', family: 'neutral' },
  expiring: { label: 'Expiring', family: 'amber' },
  expired: { label: 'Expired', family: 'red' },
  overdue: { label: 'Overdue', family: 'red' },
  'due-today': { label: 'Due today', family: 'amber' },
  'due-soon': { label: 'Due soon', family: 'amber' },
  complete: { label: 'Complete', family: 'ok' },
  superseded: { label: 'Superseded', family: 'neutral' },
  recycled: { label: 'Recycled', family: 'neutral' },
  valid: { label: 'Valid', family: 'ok' },
  unverified: { label: 'Unverified', family: 'neutral' },
  moved: { label: 'Moved', family: 'amber' },
  broken: { label: 'Broken', family: 'red' },
  mention: { label: 'Mention', family: 'gold' },
  new: { label: 'New', family: 'info' },
  disabled: { label: 'Disabled', family: 'red' },
  unanswered: { label: 'Unanswered', family: 'amber' },
} as const satisfies Record<string, StatusDefinition>;

/** Every status the design system permits. No synonyms, no new colours. */
export type StatusKey = keyof typeof STATUSES;
